import { render, staticRenderFns } from "./MainMenu.vue?vue&type=template&id=e1c03272&scoped=true&"
import script from "./MainMenu.vue?vue&type=script&lang=ts&"
export * from "./MainMenu.vue?vue&type=script&lang=ts&"
import style0 from "./MainMenu.vue?vue&type=style&index=0&id=e1c03272&scoped=true&lang=css&"
import style1 from "./MainMenu.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c03272",
  null
  
)

component.options.__file = "MainMenu.vue"
export default component.exports